module.exports = __webpack_public_path__ + "static/media/Pidgey_gaussian2.2b51fef1.png";